import { Id, ResponseId, Timestamp } from 'ev-types';

import { EdataAttributes } from 'ev-api/core/visits/params';
import { FormStatusCardVariant } from 'ev-store/customFormSidebar';

export type GetCustomFormSubmissionsResponse = {
  data: SubmissionResponse[];
  meta: {
    available_count: number;
    page: number;
    total_count: number;
  };
};

export type GetCustomFormSubmissions = {
  data: Submission[];
  meta: {
    available_count: number;
    page: number;
    total_count: number;
  };
};

export type GetSubmissionResponse = {
  data: SubmissionResponse;
};

export type GetSubmission = Submission;

export type EdataValuesResponse = EdataAttributes & {
  id: ResponseId;
  edata_definition_id: ResponseId;
  user_id: ResponseId;
  event: string;
  created_at: Timestamp;
  updated_at: Timestamp;
  value: string | string[];
};

export type SubmissionResponse = {
  created_at: Timestamp | null;
  access: SubmissionAccess | null;
  custom_form: {
    id: ResponseId;
    title: string;
    description: string;
  };
  custom_form_id: ResponseId;
  custom_form_version_id: ResponseId;
  edata_pack: null | {
    created_at: Timestamp;
    updated_at: Timestamp;
    edata_values: EdataValuesResponse[];
  };
  edata_pack_id: ResponseId | null;
  event_trigger: string;
  id: ResponseId | null;
  practice_id: ResponseId | null;
  state: string;
  state_at: null;
  submittable_id: ResponseId;
  submittable_type: string;
  submitted_by_full_name: string | null;
  submitted_by_id: ResponseId | null;
  submitted_at: Timestamp | null;
  updated_at: Timestamp | null;
  user_id: ResponseId;
  user_full_name: string;
  locked_by_id: Id | null;
  locket_at: Timestamp | null;
  locked_by_full_name: string | null;
};

export enum SubmissionAccess {
  ProviderShared = 'provider-shared',
  ProviderOnly = 'provider-only',
}

export type Submission = {
  created_at: Timestamp | null;
  shared: boolean;
  custom_form: {
    id: Id;
    title: string;
    description: string;
  };
  custom_form_id: Id;
  custom_form_version_id: Id;
  edata_pack: null | {
    created_at: Timestamp;
    updated_at: Timestamp;
    edata_values: EdataValuesResponse[];
  };
  edata_pack_id: Id | null;
  event_trigger: string;
  id: Id | null;
  practice_id: Id | null;
  state: FormStatusCardVariant;
  state_at: string | null;
  submittable_id: Id;
  submittable_type: string;
  submitted_by_full_name: string | null;
  submitted_by_id: Id | null;
  submitted_at: Timestamp | null;
  updated_at: Timestamp | null;
  user_id: Id;
  user_full_name: string;
  locked_by_id: Id | null;
  locked_at: Timestamp | null;
  locked_by_full_name: string | null;
};
